<template>
  <div>
    <div id="regions_div" style="width: 100%;" class="w-[100%] lg:h-[600px] h-[250px]"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import Papa from "papaparse";

export default defineComponent({
  name: "MapaCSVStatic",
  setup() {
    const drawRegionsMap = (dataArray: [string, number][]) => {
      const google = (window as any).google;

      const data = google.visualization.arrayToDataTable([
        ["Country", "Egresados"],
        ...dataArray
      ]);

        const options = {
            colorAxis: { colors: ["#a5aa86", "#73793B"] },
            legend: "none",
            tooltip: { trigger: "none" }, // 👈 aquí lo desactivas
        };

      const chart = new google.visualization.GeoChart(
        document.getElementById("regions_div")
      );
      chart.draw(data, options);
    };

    const loadGoogleCharts = () => {
      return new Promise<void>((resolve, reject) => {
        const script = document.createElement("script");
        script.src = "https://www.gstatic.com/charts/loader.js";
        document.body.appendChild(script);

        script.onload = () => {
            const google = (window as any).google;
            google.charts.load("current", { packages: ["geochart"], language: "es", });
            google.charts.setOnLoadCallback(() => resolve());
        };

        script.onerror = () => reject("Error al cargar Google Charts");
      });
    };

    const fetchCSV = async () => {
      const res = await fetch("../../assets/Alumnos_Egresados_Nacionalidad_Colombiana_Fusionado.csv"); // CSV estático en /public
      const text = await res.text();

      Papa.parse(text, {
        header: true,
        skipEmptyLines: true,
        complete: (results: { data: Record<string, string>[]; }) => {
          const nacionalidades: string[] = [];
          const rows = results.data as Record<string, string>[];

          rows.forEach((row) => {
            const pais = row["Nacionalidad"]?.trim();
            if (pais) nacionalidades.push(pais);
          });

          // Contar por país
          const counts: Record<string, number> = {};
          nacionalidades.forEach((pais) => {
            counts[pais] = (counts[pais] || 0) + 1;
          });

          // Preparar array para GeoChart
          const dataArray: [string, number][] = Object.entries(counts);
          drawRegionsMap(dataArray);
        },
        error: (err: any) => console.error("Error leyendo CSV:", err),
      });
    };

    onMounted(async () => {
      await loadGoogleCharts();
      await fetchCSV();
    });

    return {};
  },
});
</script>
